<template>
  <div id="app">
    <view-loader v-if="showViewLoader" margin-top-percentage="20"></view-loader>
    <router-view v-if="!showViewLoader" />

    <footer v-if="!showViewLoader" class="login-footer text-center">
      <div class="social-media">
        <a
          class="social-a"
          href="https://facebook.com/VenuzleManager/"
          target="_blank"
        >
          <i class="fa fa-fw fa-3x fa-facebook-official"></i>
        </a>
        <a class="social-a" href="https://twitter.com/venuzle/" target="_blank">
          <i class="fa fa-fw fa-3x fa-twitter-square"></i>
        </a>
        <a
          class="social-a"
          href="https://www.instagram.com/venuzle/"
          target="_blank"
        >
          <i class="fa fa-fw fa-3x fa-instagram"></i>
        </a>
      </div>
      <div class="imprint">
        Venuzle GmbH | hallo@venuzle.at<br />
        Dietrichsteinplatz 11, 8010 Graz<br />
        UID: ATU72460856 | FB: 470286y<br />
        <a class="login-footer-a" href="https://venuzle.at" target="_blank "
          >VENUZLE</a
        >
        |
        <a
          class="login-footer-a"
          href="https://sport-manager.venuzle.at"
          target="_blank"
          >Sport Manager</a
        >
        |
        <a
          class="login-footer-a"
          href="https://tennis-manager.at"
          target="_blank"
          >Tennis Manager</a
        >
      </div>
    </footer>
  </div>
</template>

<script>
import ViewLoader from "@/components/Common/ViewLoader.vue";
import Api from "@/api";

export default {
  components: {
    ViewLoader
  },

  data() {
    return {
      showViewLoader: true,
      templatLabels: null,
      loadingStartedAt: null,
      minLoadingMs: 2000
    };
  },

  mounted() {
    this.initApp(() => {
      var timeout = 0;
      var differenceInMs = window.performance.now() - this.loadingStartedAt;

      if (differenceInMs < this.minLoadingMs) {
        timeout = this.minLoadingMs - differenceInMs;
      }

      setTimeout(() => {
        this.showViewLoader = false;
      }, timeout);
    });
  },

  methods: {
    async initApp(finishCallback) {
      this.loadingStartedAt = window.performance.now();
      await this.loadTemplateLabels();

      if (typeof finishCallback === "function") {
        finishCallback();
      }
    },

    loadTemplateLabels() {
      const endpoint = "/api/internal/v1/languages/1/translations";
      // const endpoint = this.$partnerEndpoint('languages/1/translations');

      return Api()
        .get(endpoint)
        .then(response => {
          window.templateLabels = {};

          for (var i = 0; i < response.data.data.length; i++) {
            window.templateLabels[response.data.data[i].label] =
              response.data.data[i].text;
          }

          response.data.data;
        })
        .catch(() => {
          //
        });
    }
  }
};
</script>

<style scoped>
* {
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

a {
  text-decoration: underline;
}
a:hover {
  text-decoration: none;
}

.v-form a {
  color: #0088cc;
}

.modal a {
  color: #2da5da;
}

.login-footer {
  padding-top: 50px;
  color: white !important;
  bottom: 0px;
  margin-left: auto;
  margin-right: auto;
  font: 14px "Open Sans", Helvetica, Arial, sans-serif;
}

.login-footer-a,
.login-footer-a:visited {
  font-size: 14px;
  color: white;
  text-decoration: underline;
}

.v-form header {
  display: block;
  padding: 20px 20px 40px 20px;
  border-bottom: 0px solid rgba(0, 0, 0, 0.1);
  background-color: #3aa94c;
}

.v-form footer {
  padding: 15px 30px 30px 30px;
  border-top: 0px solid rgba(0, 0, 0, 0.1);
  background-color: #3aa94c;
}

.imprint {
  padding-bottom: 50px;
}

.v-form fieldset {
  display: block;
  padding: 0px 25px 0px;
  border: none;
  background-color: #3aa94c;
}

.social-media {
  padding-bottom: 20px;
}

.social-a,
.social-a:visited,
.social-a:hover {
  color: white;
  text-decoration: none !important;
}

.social-a:hover {
  color: #0088cc;
}

.v-form input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}

/**/
/* error state */
/**/
.v-form .state-error input,
.v-form .state-error select,
.v-form .state-error textarea,
.v-form .radio.state-error i,
.v-form .checkbox.state-error i,
.v-form .toggle.state-error i {
  background: #d8f3ff;
}

.v-form .state-error select + i {
  background: #d8f3ff;
  box-shadow: 0 0 0 12px #d8f3ff;
}
.v-form .toggle.state-error input:checked + i {
  background: #d8f3ff;
}
.v-form .state-error + em {
  color: #fd6d00;
  background-color: white;
  padding: 5px;
  font-weight: bold;
  font-size: 12px;
}
</style>
